'use strict';

import  Katalyo from './index.js';
//import templateCache from '/static/modules/0001_modules/ctrls/build/angularTemplates/ktroutetemplates.js';
import templateCache from '../../ctrls/build/angularTemplates/ktroutetemplates.js';
import templateCacheDir from '../../../0000_common/0001_directives/angularTemplates/build/ktdirectivetemplates.js';

angular.bootstrap(document, [Katalyo]);
